<script>
  export default {
    methods: {
      voltarAoTopo() {
        $('body,html').animate({
          scrollTop: 0
        }, 800);
      }
    },
    mounted() {
      this.$nextTick(() => {
        $(window).scroll(function () {
          if ($(window).scrollTop() > 50) {
            $('.voltar-ao-topo').fadeIn();
          } else {
            $('.voltar-ao-topo').fadeOut();
          }
        });
      });
    }
  }
</script>

<template>
  <div class="voltar-ao-topo hidden-print">
    <button 
        class="btn btn-success btn-circle"
        type="button"
        @click="voltarAoTopo"
        v-tooltip="'Voltar ao topo'">
      <i class="fa fa-arrow-up"></i>
    </button>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/VoltarAoTopo.vue